
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/technology",
      function () {
        return require("private-next-pages/services/technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/technology"])
      });
    }
  